import { FilterDocument } from '@griply/types';
import { createDefaultCompletedFilterDocument } from '@griply/utils';
import React, { useMemo, useRef, useState } from 'react';
import { useToday } from 'shared/contexts/today';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import * as Styled from './completed.style';
import { PageTopBar } from './components/page-top-bar/index';
import { TasksOverview } from './components/tasks-overview/index';

export const Completed: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.Completed, undefined);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const today = useToday();
  const defaultFilter = useMemo(
    () => createDefaultCompletedFilterDocument(today),
    [today],
  );
  const [filterDocument, setFilterDocument] =
    useState<FilterDocument>(defaultFilter);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar
            filterDocument={filterDocument}
            setFilterDocument={setFilterDocument}
          />
          <Styled.Content ref={scrollContainerRef}>
            <TasksOverview
              scrollElement={scrollContainerRef}
              filterDocument={filterDocument}
              setFilterDocument={setFilterDocument}
              defaultFilter={defaultFilter}
            />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
